import { isNativeMobile } from '@droplet-tech-code/core-elements/module/utils/utils.helper';

import { PageHeader } from '~/components/Page/Page.Header';
import { AppText } from '~/components/Text';
import { translate } from '~/utils/translation.utils';

export const BookingsListHeaderFullName = ({
  fullName,
  onPress,
}: {
  fullName: string;
  onPress?: () => void;
}) => {
  return (
    <PageHeader
      title={translate('bookings.bookingsByName')}
      Subtitle={Subtitle({ fullName })}
      withBack={isNativeMobile}
      iconRight={{
        color: 'monochrome',
        icon: 'refresh',
        onPress,
      }}
    />
  );
};

const Subtitle = ({ fullName }: { fullName: string }) => {
  return <AppText.Small color="monochrome-mid">{fullName}</AppText.Small>;
};
